import { getGetAuthorisationErrorMessage as errorMessage } from "./constants";

const getGetAuthorisationError = getAuthorisation => {
  if (!["function", "undefined"].includes(typeof getAuthorisation)) {
    return errorMessage;
  }
};

export default getGetAuthorisationError;
